import React from "react";
import { MenuItem, Select } from "@mui/material";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";

/**
 * Dropdown that matches the phone number select style (Incoming Call section).
 * Use for destination, recording, and other call action dropdowns.
 */
// Box style to match phone number field (visible border, rounded corners)
const boxSx = {
  border: "1px solid #D1D5DB",
  borderRadius: "8px",
  backgroundColor: "white",
  minHeight: 40,
  width: "100%",
};

const selectSx = {
  width: "100%",
  minHeight: 40,
  fontSize: "15px",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSelect-select": {
    py: 0.75,
    paddingLeft: "16px !important",
    paddingRight: "32px !important",
    textAlign: "left",
    boxSizing: "border-box",
  },
  "& .MuiOutlinedInput-input": {
    paddingLeft: "16px !important",
    paddingRight: "32px !important",
    textAlign: "left",
  },
  "&.MuiOutlinedInput-root": {
    border: "none",
    minHeight: 40,
    textAlign: "left",
    padding: 0,
  },
  "&.MuiOutlinedInput-root:hover": {
    border: "none",
  },
  "&.MuiOutlinedInput-root.Mui-focused": {
    border: "none",
    boxShadow: "none",
  },
};

const ADD_OPTION_VALUE = "__route_select_add__";

const RouteSelect = ({
  value,
  onChange,
  options = [],
  placeholder = "Select...",
  disabled = false,
  fullWidth = true,
  displayEmpty = true,
  renderOptionLabel,
  /** Optional: { label: string, onClick: () => void } — adds an "Add..." item at the bottom that opens a modal */
  addOption,
}) => {
  const handleChange = (v) => {
    if (v === ADD_OPTION_VALUE) {
      addOption?.onClick?.();
      return;
    }
    onChange(v);
  };

  return (
    <div style={boxSx} className="w-full">
      <Select
        fullWidth={fullWidth}
        displayEmpty={displayEmpty}
        value={value ?? ""}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        IconComponent={KeyboardArrowDown}
        sx={selectSx}
        inputProps={{
          style: { paddingLeft: 16, paddingRight: 32, textAlign: "left", boxSizing: "border-box" },
        }}
        renderValue={(v) => {
          if (v == null || v === "" || v === ADD_OPTION_VALUE) return placeholder;
          const opt = options.find((o) => o.value === v);
          if (renderOptionLabel && opt) return renderOptionLabel(opt);
          return opt?.label ?? v;
        }}
      >
        <MenuItem value="">
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((opt, idx) => (
          <MenuItem
            key={opt.value ?? idx}
            value={opt.value}
            disabled={opt.disabled}
            title={opt.title}
          >
            {renderOptionLabel ? renderOptionLabel(opt) : opt.label}
          </MenuItem>
        ))}
        {addOption?.label && (
          <MenuItem value={ADD_OPTION_VALUE} sx={{ borderTop: "1px solid", borderColor: "divider" }}>
            <em className="text-indigo-600">{addOption.label}</em>
          </MenuItem>
        )}
      </Select>
    </div>
  );
};

export default RouteSelect;
